import { useEffect, useState } from "react";
import { api } from "./api";
import { useMarket } from "./store";

export function useUnderlyings() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/fno/underlyings").then((r) => setList(r.data)).catch(() => {}); }, []);
  return list;
}

export function useChain(underlying, window = 15) {
  const [expiries, setExpiries] = useState([]);
  const [expiry, setExpiry] = useState("");
  const [chain, setChain] = useState(null);
  const addMeta = useMarket((s) => s.addMeta);
  const spot = useMarket((s) => s.ticks[underlying]?.ltp);
  useEffect(() => {
    if (!underlying) return;
    setChain(null);
    api.get("/fno/expiries", { params: { underlying_key: underlying } }).then((r) => { setExpiries(r.data); setExpiry(r.data[0] || ""); });
  }, [underlying]);
  useEffect(() => {
    if (!underlying || !expiry) return;
    api.get("/fno/chain", { params: { underlying_key: underlying, expiry } }).then((r) => {
      const m = {};
      Object.entries(r.data.meta).forEach(([k, v]) => { m[k] = { ...v, instrument_key: k, expiry, underlying_key: underlying, exchange: k.startsWith("BSE") ? "BSE" : "NSE" }; });
      addMeta(m);
      setChain(r.data);
    }).catch(() => setChain({ strikes: [], lot_size: 1 }));
  }, [underlying, expiry, addMeta]);
  const all = chain?.strikes || [];
  let atmIdx = 0;
  if (spot && all.length) atmIdx = all.reduce((b, r, i) => (Math.abs(r.strike - spot) < Math.abs(all[b].strike - spot) ? i : b), 0);
  else atmIdx = Math.floor(all.length / 2);
  const rows = all.slice(Math.max(atmIdx - window, 0), atmIdx + window + 1);
  return { expiries, expiry, setExpiry, chain, rows, atm: all[atmIdx]?.strike, spot, lot: chain?.lot_size || 1 };
}
